/** Starter stub — EMS fee installment helpers (platform template). */

export const FEE_INSTALLMENT_ALREADY_PAID_MSG =
  "This installment already has a paid fee receipt and cannot be changed to unpaid.";

/** Collect installment ids that already have a paid fee receipt. */
export function getPaidFeeReceiptInstallmentIds(studentFees = []) {
  const list = Array.isArray(studentFees) ? studentFees : [];
  const ids = new Set();

  for (const fee of list) {
    const status = String(
      fee?.payment_status ?? fee?.status ?? fee?.fee_status ?? ""
    )
      .trim()
      .toLowerCase();
    const isPaid = status === "paid" || status === "completed" || status === "success";
    if (!isPaid) continue;

    const installmentId =
      fee?.organization_ems_fee_installment_id ??
      fee?.fee_installment_id ??
      fee?.installment_id;
    if (installmentId != null && String(installmentId).trim() !== "") {
      ids.add(installmentId);
    }
  }

  return Array.from(ids);
}

/** Returns error string or null when status change is allowed. */
export function validateFeeInstallmentStatusChange() {
  return null;
}
